import i18next from 'i18next';


var queryString = {};
if (typeof window !== `undefined`) {
  queryString = window.location.search;
}

const urlParams = new URLSearchParams(queryString);

i18next.init({
    fallbackLng: urlParams.get('hl') || 'fr',
    resources: {
        en: {
            translations: require('../locales/translations/en.json')
        },
        fr: {
            translations: require('../locales/translations/fr.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations',
    returnObjects: true,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
        escapeValue: false, // not needed for react!!
    },
    react: {
        wait: true,
        useSuspense: false,
    },
});

i18next.languages = ['en', 'fr'];

export default i18next;
